import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Yahoo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M223.69 141.06L167 284.23l-56-143.17H14.93l105.83 249.13L82.19 480h94.17l140.91-338.94zm105.4 135.79a58.22 58.22 0 1058.22 58.22 58.22 58.22 0 00-58.22-58.22zM394.65 32l-93 223.47h104.79L499.07 32z"
  }));
});
Yahoo.displayName = 'Yahoo';
export var YahooDimensions = {
  height: 512,
  width: 512
};